import { useTranslation } from "react-i18next";

const NoDataPanel = ({ panel, title }) => {
    const { t } = useTranslation();
    return (
        <div id={panel ? `panel_nodata-${panel.id}-${panel.chart_type}` : 'panel_nodata'} className='panel-placeholder'>
            <h2>{title || t("panels.noData")}</h2>
            {panel?.name ? <h3>{panel.name}</h3> : null}
        </div>
    )
}

export default NoDataPanel;
